import "./Start.css";

function Start(){
  return(
    <div className="start-step">
      <h1 className="pb-5">Getting start is easy as 1, 2, 3!</h1>
      <ol className="steps">
        <li><b>Create a free account</b></li>
        <li><b>Search for jobs through the company and job tabs</b></li>
        <li><b>Apply!</b></li>
      </ol>
    </div>
  );
}

export default Start;